import { alpha, darken, Skeleton } from "@mui/material";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_BLACK, COLOR_BLACK_LIGHTER, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING, SPACING_HALF } from "helpers/spacings";
import React from "react";

export default function LeaderboardIntroBanner({ data, teamData, effectiveView, viewSet }) {
  const colorDarken = darken(COLOR_BLACK_LIGHTER, 0.5);

  const isTeams = effectiveView === "teams";
  const title = isTeams
    ? (teamData?.name ?? <Skeleton style={{ backgroundColor: alpha(COLOR_WHITE, 0.2), width: 300 }} />)
    : (data?.season?.nameWithLeague ?? <Skeleton style={{ backgroundColor: alpha(COLOR_WHITE, 0.2), width: 300 }} />);

  // Subtitle is the org name in both views; falls back to a skeleton until the relevant data loads.
  const loaded = isTeams ? !!teamData : !!data?.season;
  const orgName = isTeams ? teamData?.orgName : data?.season?.league?.orgName;

  return (
    <div
      style={{
        color: COLOR_WHITE,
        background: `linear-gradient(0deg, ${COLOR_BLACK_LIGHTER}, ${colorDarken})`,
        display: "flex",
        flexFlow: "row wrap",
        alignItems: "center",
        padding: SPACING,
        gap: `calc(${SPACING} * 2)`,
      }}
    >
      <div
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          gap: SPACING_HALF,
          margin: "0 auto",
          maxWidth: MAX_CONTENT_WIDTH,
          width: `calc(100vw - ${SPACING} * 2)`,
        }}
      >
        {/* Title + League/Teams toggle: one line on desktop; on mobile the toggle wraps
            directly under the team name (left-aligned). */}
        <div
          style={{
            display: "flex",
            flexFlow: "row wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: SPACING_HALF,
            paddingTop: SPACING_HALF,
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: `min(44px, 10vw)`,
              textTransform: "uppercase",
              fontFamily: FONT_FAMILY_GRAPHIK,
              fontWeight: 800,
            }}
          >
            {title}
          </h1>

          {/* League / Teams toggle */}
          <div
            style={{
              display: "flex",
              flexFlow: "row nowrap",
              flexShrink: 0,
              background: alpha(COLOR_WHITE, 0.15),
              borderRadius: 6,
              gap: 2,
            }}
          >
            {["league", "teams"].map((v) => (
              <button
                key={v}
                onClick={() => viewSet(v === "league" ? null : v)}
                style={{
                  background: effectiveView === v ? COLOR_WHITE : "transparent",
                  color: effectiveView === v ? COLOR_BLACK : COLOR_WHITE,
                  border: "none",
                  borderRadius: 6,
                  fontFamily: FONT_FAMILY_GRAPHIK,
                  fontWeight: effectiveView === v ? 600 : 400,
                  fontSize: 14,
                  textTransform: "capitalize",
                  cursor: "pointer",
                  minHeight: 44,
                  padding: `10px 14px`,
                  transition: "background 0.15s, color 0.15s",
                }}
              >
                {v === "league" ? "League" : "Teams"}
              </button>
            ))}
          </div>
        </div>

        <div
          style={{
            fontFamily: FONT_FAMILY_GRAPHIK,
            fontSize: 12,
            opacity: 0.6,
          }}
        >
          {loaded ? orgName : <Skeleton style={{ backgroundColor: alpha(COLOR_WHITE, 0.2), width: 260 }} />}
        </div>
      </div>
    </div>
  );
}
